import React, { useEffect, createElement } from 'react';
import { StickyNav } from './components/StickyNav';
import { Hero } from './components/Hero';
import { PropertyStats } from './components/PropertyStats';
import { WhyCarefree } from './components/WhyCarefree';
import { AboutHome } from './components/AboutHome';
import { Agent } from './components/Agent';
import { ScheduleTour } from './components/ScheduleTour';
import { Footer } from './components/Footer';
const META_TITLE = '38809 N Boulder View Dr · North Scottsdale Luxury Estate | Patty LaBenske & Simon Patton';
const META_DESCRIPTION = 'Discover 38809 N Boulder View Dr — a 6 bed, 5 bath luxury Sonoran Desert estate in North Scottsdale, AZ. Presented by Patty LaBenske & Simon Patton of HomeSmart NEXT. Schedule your private tour today.';
function setMeta(name: string, content: string, attr: 'name' | 'property' = 'name') {
  let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  useEffect(() => {
    document.title = META_TITLE;
    setMeta('description', META_DESCRIPTION);
    setMeta('og:title', META_TITLE, 'property');
    setMeta('og:description', META_DESCRIPTION, 'property');
    setMeta('og:type', 'website', 'property');
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', META_TITLE);
    setMeta('twitter:description', META_DESCRIPTION);
  }, []);
  return <div className="min-h-screen w-full bg-cream font-sans text-stone-deep selection:bg-sand/30" data-id="element-0">
      <StickyNav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PropertyStats data-id="element-4" />
        <WhyCarefree data-id="element-5" />
        <AboutHome data-id="element-6" />
        <Agent data-id="element-7" />
        <ScheduleTour data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}